import { defineMessages } from "react-intl"

export const messages = defineMessages({
    cardNumber: {
        id: "rf.cc.card_number",
        defaultMessage: "Card Number",
    },
    cardholderName: {
        id: "rf.cc.cardholer_name",
        defaultMessage: "Cardholder Name",
    },
    cardInformation: {
        id: "rf.cc.card_information_header",
        defaultMessage: "Card Information",
    },
    expDate: {
        id: "rf.cc.exp_date",
        defaultMessage: "MM/YY",
    },
    cvc: {
        id: "rf.cc.cvc",
        defaultMessage: "CVC",
    },
    zipCode: {
        id: "rf.cc.zipCode",
        defaultMessage: "Zip Code",
    },
    pay: {
        id: "rf.cc.pay_btn_text",
        defaultMessage: "Pay",
    },
    storeDetails: {
        id: "rf.cc.store_card_on_file",
        defaultMessage: "Store Details",
    },
    saveCardOnFile: {
        id: "rf.cc.save_card_on_file_label",
        defaultMessage: "Save your card for future payments"
    },
    genericErrorMessage: {
        id: "rf.generic_payment_error.something_went_wrong",
        defaultMessage: "Something went wrong, please try again"
    }
})


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/messages.ts